import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { claritasUrlFor } from '@/lib/movedToClaritas';

/**
 * Stands where a page that moved to the Claritas app used to be, and sends the
 * visitor to its new address (lib/movedToClaritas.ts). `replace` keeps the old
 * address out of the back button, so Back does not bounce.
 */
export function MovedToClaritas() {
  const { pathname, search, hash } = useLocation();
  const url = claritasUrlFor(pathname, search, hash);

  useEffect(() => {
    if (url) window.location.replace(url);
  }, [url]);

  if (!url) return <Navigate to="/elevation/home" replace />;

  return (
    <div className="min-h-[50vh] flex items-center justify-center p-8 text-center">
      <p className="text-sm text-[var(--text-ter)]">
        This page has moved to the Claritas app.{' '}
        <a href={url} className="underline">
          Open it there
        </a>
        .
      </p>
    </div>
  );
}
